import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'ol/ol.css';

import { createApp } from 'vue'
import App from './App.vue'

createApp(App).mount('#app')
